/*=====================================
    ProductCheckoutView

    Author: Ac
    CreateTime: 2018 / 10 / 04
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import CheckoutView from 'components/member/CheckoutView';

/*--------------------------
    Styled
--------------------------*/
const Container = styled.div`
    margin-bottom: ${GlobalStyle.ViewSpace}px;
    display: flex;
    align-items: center;
    font-size: 14px;
`

const Title = styled.div`
    color: ${props => props.highlight? '#F75C2F' : '#4a4a4a'};
    cursor: pointer;
`

const Icon = styled.i`
    margin: 0 16px;
    font-size: 20px;
    color: #9B9B9B;
    font-weight: bold;
`
/*--------------------------
    Main Component
--------------------------*/
class ProductCheckoutView extends Component {

    // static propTypes = {
    // };

    constructor(props) {
        super(props);

        this.state = {
            gamaName: '',
            gameid: '',
        };
    }

    handleGameData = (gamaName, gameid) => {
        this.setState({ gamaName, gameid });
    }

    render() {
        const { gamaName, gameid } = this.state;
        return (
            <GlobalStyle.SubContainer>
                {gamaName && gameid && this.renderBreadCrumbs()}
                <CheckoutView handleGameData={this.handleGameData} />
            </GlobalStyle.SubContainer>
        );
    }

    renderBreadCrumbs = () => (
        <Container>
            <CupoySrefView statename={CupoyRouter.STATES.GAME}>
                <Title highlight>虛寶市集</Title>
            </CupoySrefView>
            <Icon className="zmdi zmdi-chevron-right" />
            <CupoySrefView
                statename={CupoyRouter.STATES.GAME_TEMP_TRANSACTION}
                params={{ gameid: this.state.gameid }}
            >
                <Title>{this.state.gamaName.trim()}</Title>
            </CupoySrefView>
            <Icon className="zmdi zmdi-chevron-right" />
            <Title>結帳</Title>
        </Container>
    )
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(ProductCheckoutView);